<template>
  <div class="not-found">
    <h1>404</h1>
    <p>{{ $t("Oops! The page you're looking for doesn't exist.") }}</p>

    <router-link to="/" class="cmn--btn">
      <span>{{ $t('Go Back Home') }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 10vh;
  height: 50vh;
}
.not-found h1 {
  font-size: 6rem;
  color: #ff4040;
}
.not-found p {
  font-size: 1.5rem;
  margin: 1rem 0;
}
</style>
